import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 父路由
let chain = ["eth"];
// 首页路由
let routes = [
  {
    path: "/",
    redirect: { name: "eth" },
  },
];

let xhr = new XMLHttpRequest();
xhr.open("GET", "https://api.maiziqianbao.net/apiChain/getEvmChains", false);
xhr.send();
if (xhr.responseText && JSON.parse(xhr.responseText).data) {
  var chains = JSON.parse(xhr.responseText).data;
  let nameList = {},
    infoList = {},
    routerList = [];
  chains.sort((a,b)=>a.name.localeCompare(b.name)).map((chain) => {
    let index = encodeURI(chain.chain.toLowerCase());
    nameList[index] = chain.name;
    routerList.push(index);
    infoList[index] = {
      rpc: chain.rpc,
      ws: null,
      price: chain.price,
      logo: chain.logo,
      token: chain.token,
      chainType: chain.chainType,
      chainID: chain.chainID,
      name: chain.name,
      explorerUrl: chain.explorerUrl,
    };
  });
  chain = routerList;
  sessionStorage.setItem("routerList", JSON.stringify(routerList));
  sessionStorage.setItem("chainNameList", JSON.stringify(nameList));
  sessionStorage.setItem("chainList", JSON.stringify(infoList));
}
chain.forEach((val) => {
  routes = routes.concat([
    {
      path: "/" + val,
      name: val,
      component: () => import("@/components/home"),
      redirect: `/${val}/assets`,
      props: (route) => ({
        addr: route.query.addr,
      }),
      children: [
        {
          path: "assets",
          component: () => import("@/components/assets.vue"),
        },
        {
          path: "collectibles",
          component: () => import("@/components/collectibles.vue"),
        },
      ],
    },
  ]);
});
export default new Router({
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
